module.exports = __webpack_public_path__ + "img/dance-test-icon11.6859b35f.png";